import React from 'react';
import { HIRING_PARTNERS } from '../data/coursesData';
import { Briefcase, TrendingUp, Award, Building2 } from 'lucide-react';

export default function Placements() {
  return (
    <section id="placements" style={{ padding: '5rem 0', backgroundColor: '#F8FAFC' }}>
      <div className="container">

        {/* Section Header */}
        <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 3.5rem auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            backgroundColor: '#ECFDF5',
            color: '#047857',
            fontWeight: 700,
            fontSize: '0.82rem',
            padding: '0.35rem 0.9rem',
            borderRadius: '9999px',
            marginBottom: '0.75rem'
          }}>
            <Briefcase size={14} color="#059669" /> Corporate Career Support
          </div>
          <h2 style={{ fontSize: '2.3rem', fontWeight: 800, color: '#0F2537', letterSpacing: '-0.02em' }}>
            Career & Placement Assistance
          </h2>
          <p style={{ fontSize: '1.05rem', color: '#64748B', marginTop: '0.5rem', lineHeight: 1.6 }}>
            Our dedicated placement cell connects Christ Online graduates directly with leading global corporations, tech giants, and Fortune 500 companies.
          </p>
        </div>

        {/* Stat Highlights Row */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3.5rem'
        }}>
          {[
            { label: "Corporate Recruiters", value: "500+", sub: "Active hiring partners", icon: <Building2 size={24} color="#2563EB" /> },
            { label: "Average CTC Package", value: "₹8.5 LPA", sub: "Across PG & UG degrees", icon: <TrendingUp size={24} color="#059669" /> },
            { label: "Highest Package", value: "₹24 LPA", sub: "International Tech Offer", icon: <Award size={24} color="#D4AF37" /> },
            { label: "Career Salary Hike", value: "54% Avg", sub: "For working professionals", icon: <Briefcase size={24} color="#7C3AED" /> }
          ].map((stat, idx) => (
            <div key={idx} className="glass-card" style={{ padding: '1.5rem', textAlign: 'center' }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                backgroundColor: '#F1F5F9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 0.85rem auto'
              }}>
                {stat.icon}
              </div>
              <div style={{ fontSize: '1.8rem', fontWeight: 800, color: '#0F2537', lineHeight: 1.1 }}>
                {stat.value}
              </div>
              <div style={{ fontSize: '0.9rem', fontWeight: 700, color: '#334155', marginTop: '0.25rem' }}>
                {stat.label}
              </div>
              <div style={{ fontSize: '0.78rem', color: '#64748B', marginTop: '0.15rem' }}>
                {stat.sub}
              </div>
            </div>
          ))}
        </div>

        {/* Hiring Partners Grid - Clean Text Cards Matching Screenshot */}
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '20px',
          padding: '2.5rem',
          boxShadow: '0 4px 20px rgba(15, 23, 42, 0.06)',
          border: '1px solid #E2E8F0'
        }}>
          <h3 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#0F2537', textAlign: 'center', marginBottom: '2rem' }}>
            Where Our Alumni Work
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: '1.25rem',
            alignItems: 'center'
          }}>
            {HIRING_PARTNERS.map((partner, pIdx) => (
              <div key={pIdx} style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #E2E8F0',
                borderRadius: '16px',
                padding: '1.35rem 1rem',
                textAlign: 'center',
                transition: 'all 0.25s ease',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.02)'
              }}>
                <div style={{ fontSize: '1.2rem', fontWeight: 800, color: '#0F2537', letterSpacing: '-0.01em' }}>
                  {partner.name}
                </div>
                <div style={{ fontSize: '0.76rem', color: '#64748B', marginTop: '0.25rem', fontWeight: 500 }}>
                  {partner.tag}
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
